<template>
 <div class="page_wrapper row p-0">
    <login-header :showLogin ="true" :showSignUp="false" @openModal="openModal"></login-header>
     <div class="col-sm-12 p-0 checkbox-error-section" v-if="showTopBannerMessage">
            <div><img class="check-box-error-info" src="/static/images/icons/check-box-error-info.png" /></div>
            <div class="checkbox-error" >{{termsErr}}</div>
            <div><img class="chechBox-error-cancel-icon" src="/static/images/icons/chechBox-error-cancel-icon.png" @click="closeTopBannerMessage"/></div>
      </div>
    <div :class="{'hide_banner':!isTokenValid}">
      <main class="col-xs-12 p-0">
        <div class="col-xs-12 p-0 d-flex justify-content-center">
           <div class="reset-whitebox" v-if="isTokenValid">
            <p class="page_header">{{ $t('createNewAccount')}}</p>
            <p class="enter-a-password">{{ $t('passwordNewValidation1')}}</p>
            <form @submit.prevent="confirmAccount">
              <div class="reset-container">
                <div class="reset-input" :class="$v.data.password.$error?'pb-9':'pb-14'">
                  <label for="password" class="float-left">{{$t('newPassword')}}</label>
                  <span class="required_astric">*</span>
                  <input
                    id="resetPassword"
                    class="reset-input-box-without-icon landing-input-field"
                    v-model.trim="$v.data.password.$model"
                    type="password"
                    name="reset_Password"
                    :placeholder="$t('newPassword')"
                    :class="{ 'field_error': $v.data.password.$error }"
                    @input="validate"
                  />
                  <span>
                    <img v-if="showPassword"
                         src="/static/images/icons/eye_icon_ul.svg"
                         alt="eye-image"
                         id="togglePassword"
                         @click="switchResetVisibility()"
                       />
                       <img v-if="!showPassword"
                         src="/static/images/icons/show_password_icon.svg"
                         alt="eye-slash-image"
                         id="togglePassword"
                         @click="switchResetVisibility()"
                       />
                  </span>
                  <div
                    class="col-md-12 col-xs-12 col-sm-12 alert alert-dismissible alert-danger"
                    id="divPasswordValidationResult"
                    v-if="!passwordError && data.password"
                  >
                    <span class="cancel-icon" @click='reset()'>&times;</span>
                    <p class="password-must">{{$t('passwordMust')}}:</p>
                    <ul class="password-cond">
                      <div v-if="counter < 3">
                        <div :key="item.message" v-for="item of verification">
                          <li
                            id="capital"
                            class="mandatory-field"
                            v-if="!item.valid"
                          >{{item.message}}</li>
                        </div>
                      </div>
                      <li
                        id="length"
                        class="mandatory-field"
                        v-if="!isPasswordLength"
                      >{{$t('beAtLeast')}}</li>
                    </ul>
                  <div
                    class="custom-error-class"
                    v-if="!data.password && submitStatus"
                  >
                    {{$t('pleaseEnterAPassword')}}</div>
                  </div>
                </div>
                <div class="error_text" v-if="$v.data.password.$error">
                  <p v-if="!$v.data.password.required">{{ $t('passwordRequired')}}</p>
                  <!-- <p v-if="$v.data.password.required&&!$v.data.password.passwordValidation">
                  {{ $t('passwordValidation1')}}
                  </p> -->
                </div>
              </div>
              <div class="reset-container" :class="$v.data.confirm_password.$error?'':'mb-26'">
                <div class="reset-input">
                  <label for="password" class="float-left">{{$t('confirmPassword')}}</label>
                  <span class="required_astric">*</span>
                  <input
                    id="confirmPassword"
                    class="reset-input-box-without-icon landing-input-field"
                    v-model.trim="$v.data.confirm_password.$model"
                    type="password"
                    name="confirm_password"
                    :placeholder="$t('confirmPassword')"
                    :class="{ 'field_error': $v.data.confirm_password.$error }"
                  />
                  <span>
                    <img v-if="showConfirmPassword"
                          src="/static/images/icons/eye_icon_ul.svg"
                          alt="eye-image"
                          id="togglePassword"
                          @click="switchConfirmVisibility()"
                        />
                    <img
                        v-if="!showConfirmPassword"
                        src="/static/images/icons/show_password_icon.svg"
                        alt="eye-slash-image"
                        id="togglePassword"
                        @click="switchConfirmVisibility()"
                      />
                  </span>
                </div>
                <div class="error_text" v-if="$v.data.confirm_password.$error"  :class="$v.data.confirm_password.$error?'pt-9':''">
                  <p v-if="!$v.data.confirm_password.required">{{$t('pleaseConfirmYourPassword')}}</p>
                  <p
                    v-if="$v.data.confirm_password.required&&!$v.data.confirm_password.sameAsPassword"
                  >{{ $t('passwordValidation2')}}</p>
                </div>
              </div>
              <div class="confirm-checkbox-container plr-39-42" :class="this.$i18n.locale=='English'?'pr-66':'pr-42'">
                <!-- <input
                  class="reset-checkbox-input"
                  type="checkbox"
                  v-model="$v.data.terms_conditions.$model"
                  @change="checkTermsAndConditions"
                /> -->
                <!-- <label></label> -->
                <div class="checkbox-wrapper">
                  <label class="custom-checkbox">
                    <input type="checkbox" @change="checkTermsAndConditions" v-model="$v.data.terms_conditions.$model" />
                    <span class="select-check"></span>
                  </label>
                </div>
                <p class="reset-checkbox-text pl-20">
                  <span class="change-password-black-text">{{$t('registerAgreementLine1')}} </span><span class="change-password-blue-text cursor-pointer" @click="openModal('sass')">{{$t('registerAgreementLineColorChanged')}}</span><span class="change-password-black-text"> and the </span><span class="change-password-blue-text cursor-pointer" @click="openModal('termsOfUse')">{{ $t('registerAgreementLine2') }}</span>
                </p>
                </div>
                <!-- <div class="checkbox-error-section">
                  <div class="error_text" v-if="$v.data.terms_conditions.$error">
                  <p v-if="$v.data.terms_conditions.required">{{ $t('selectSaaSagreement')}}</p>
                </div>
                </div> -->
              <div class="reset-checkbox-container cust_checkbox mb-21 justify-start plr-39-42 pt-6">
                <!-- <input
                  class="reset-checkbox-input"
                  type="checkbox"
                  v-model="$v.data.privacy_notice.$model"
                  @change="checkPrivacyNotice"
                /> -->
                <label class="pr-0"></label>
                <div class="checkbox-wrapper">
                  <label class="custom-checkbox">
                    <input type="checkbox" @change="checkPrivacyNotice" v-model="$v.data.privacy_notice.$model" />
                    <span class="select-check"></span>
                  </label>
                </div>
                <p class="reset-checkbox-text pl-15">
                  <span class="change-password-black-text">{{$t('privacyNoticeAcknowledge')}} </span><span class="change-password-blue-text cursor-pointer" @click="openModal('privacyPolicy')">{{$t('privacyNotice')}}</span>
                </p>
              </div>
              <div class="change-password-btn">
                  <button
                  class="confirm-btn btn-success"
                  type="submit"
                  :disabled="disableButton"
                >{{ButtonText}}</button>
              </div>
            </form>
          </div>
           <div v-else>
           <invalid-token-message :page="'confirmregister'"></invalid-token-message>
         </div>
        </div>
      </main>
    </div>
    <TermsOfStatus :termsOfStatus="agreementType"></TermsOfStatus>
  </div>
</template>
<script>
import $ from 'jquery';
import { required, sameAs, helpers } from 'vuelidate/lib/validators';
import {
  confirmRegisterPassword,
  validateRegisterToken,
} from '../../apis/passwords';
import { PasswordValidation } from '../../utils/common';
import InvalidTokenMessage from '../UIComponents/InvalidTokenMessage.vue';
import LoginHeader from '../Login/LoginHeaderNew.vue';
import TermsOfStatus from '../Login/TermsOfStatus.vue';
import EventBus from '../../utils/event-bus';
import {
  isContainsUpperCase,
  isContainsLowerCase,
  isContainsDigit,
  isContainsSpecialChar,
  checkConditions,
} from './validator';

const passwordValidation = helpers.regex('passwordValidation', PasswordValidation);
export default {
  data() {
    return {
      counter: 0,
      verification: [
        { message: 'Have at least one capital letter', valid: false },
        { message: 'Have at least one lowercase letter', valid: false },
        { message: 'Have at least one number', valid: false },
        { message: 'Have at least one special character !@#$.,+=( )_%^&*', valid: false },
      ],
      passwordError: false,
      isPasswordLength: false,
      showPassword: true,
      showConfirmPassword: true,
      agreementType: '',
      data: {
        password: '',
        confirm_password: '',
        terms_conditions: false,
        privacy_notice: false
      },
      errorMessage: '',
      isTokenValid: true,
      disableButton: false,
      ButtonText: '',
      showTopBannerMessage: '',
      termsErr: '',
    };
  },
  components: {
    TermsOfStatus,
    InvalidTokenMessage,
    LoginHeader,
  },
  validations: {
    data: {
      password: {
        required,
        passwordValidation,
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs(function () { //eslint-disable-line
          return this.data.password;
        }),
      },
      terms_conditions: {
        required,
        checked(value) {
          return value;
        },
      },
      privacy_notice: {
        required,
        checked(value) {
          return value;
        },
      },
    },
  },
  async created() {
    await this.validateToken();
    this.ButtonText = this.$i18n.locale === 'Portuguese' ? 'Confirmar conta' : 'Confirm Account';
    EventBus.$on('languageChanged', (language) => {
      this.ButtonText = language === 'Portuguese' ? 'Confirmar conta' : 'Confirm Account';
      if (this.$i18n.locale === 'Portuguese') {
        this.verification = [
          { message: 'Ter pelo menos uma letra maiúscula', valid: false },
          { message: 'Ter pelo menos uma letra minúscula', valid: false },
          { message: 'Ter pelo menos um número', valid: false },
          { message: 'Ter pelo menos um caractere especial !@#$.,+=( )_%^&*', valid: false },
        ];
      } else {
        this.verification = [
          { message: 'Have at least one capital letter', valid: false },
          { message: 'Have at least one lowercase letter', valid: false },
          { message: 'Have at least one number', valid: false },
          { message: 'Have at least one special character !@#$.,+=( )_%^&*', valid: false },
        ];
      }
    });
    if (this.$i18n.locale === 'Portuguese') {
      this.verification = [
        { message: 'Ter pelo menos uma letra maiúscula', valid: false },
        { message: 'Ter pelo menos uma letra minúscula', valid: false },
        { message: 'Ter pelo menos um número', valid: false },
        { message: 'Ter pelo menos um caractere especial !@#$.,+=( )_%^&*', valid: false },
      ];
    } else {
      this.verification = [
        { message: 'Have at least one capital letter', valid: false },
        { message: 'Have at least one lowercase letter', valid: false },
        { message: 'Have at least one number', valid: false },
        { message: 'Have at least one special character !@#$.,+=( )_%^&*', valid: false },
      ];
    }
  },
  methods: {
    validate() {
      this.counter = 0;
      if (this.data.password) {
        this.verification[0].valid = isContainsUpperCase(
          this.data.password,
        );
        this.verification[1].valid = isContainsLowerCase(
          this.data.password,
        );
        this.verification[2].valid = isContainsDigit(this.data.password);
        this.verification[3].valid = isContainsSpecialChar(
          this.data.password,
        );
      }
      this.counter = checkConditions(this.data.password);
      this.isPasswordLength = false;
      if (this.data.password.length >= 10) this.isPasswordLength = true;

      this.passwordError = false;
      if (this.isPasswordLength && this.counter >= 3) {
        this.passwordError = true;
      }
    },
    reset() {
      $('#divPasswordValidationResult').hide();
    },
    closeTopBannerMessage() {
      this.showTopBannerMessage = false;
    },
    checkTermsAndConditions() {
      if (this.$v.data.terms_conditions.$model) {
        this.showTopBannerMessage = false;
      } else {
        this.termsErr = this.$i18n.locale === 'Portuguese' ? 'Por favor selecione as caixas de seleção de confirmação' : 'Please select the acknowledgement checkboxes';
        this.showTopBannerMessage = true;
      }
    },
    checkPrivacyNotice() {
      if (this.$v.data.privacy_notice.$model) {
        this.showTopBannerMessage = false;
      } else {
        this.termsErr = this.$i18n.locale === 'Portuguese' ? 'Por favor selecione as caixas de seleção de confirmação' : 'Please select the acknowledgement checkboxes';
        this.showTopBannerMessage = true;
      }
    },
    openModal(data) {
      console.log('openSaasModal');
      this.agreementType = data;
      $('#agreements').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    switchResetVisibility() {
      this.showPassword = !this.showPassword;
      const resetPasswordField = document.querySelector('#resetPassword');
      if (resetPasswordField.getAttribute('type') === 'password') {
        resetPasswordField.setAttribute('type', 'text');
      } else {
        resetPasswordField.setAttribute('type', 'password');
      }
    },
    switchConfirmVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
      const confirmPasswordField = document.querySelector('#confirmPassword');
      if (confirmPasswordField.getAttribute('type') === 'password') {
        confirmPasswordField.setAttribute('type', 'text');
      } else {
        confirmPasswordField.setAttribute('type', 'password');
      }
    },
    async confirmAccount() {
      this.$v.$touch();
      if (!this.$v.data.terms_conditions.$model || !this.$v.data.privacy_notice.$model) {
        this.showTopBannerMessage = true;
        this.termsErr = '';
        this.termsErr = this.$i18n.locale === 'Portuguese' ? 'Por favor selecione as caixas de seleção de confirmação' : 'Please select the acknowledgement checkboxes';
      }
      if (!this.$v.$invalid) {
        this.disableButton = true;
        this.ButtonText = this.$i18n.locale === 'Portuguese' ? 'Enviando... ' : 'Submitting...';
        const result = await confirmRegisterPassword(
          this.data,
          this.$route.params.token,
        );
        this.disableButton = true;
        this.ButtonText = 'Confirm Account';
        if (result.token && result.token === 'invalid') {
          this.isTokenValid = false;
        } else if (result.status) {
          this.$router.push({ name: 'login', params: { successMessage: result.message } });
        } else if (!result.status) {
          this.errorMessage = result.message;
        }
      }
    },
    async validateToken() {
      const result = await validateRegisterToken(this.$route.params.token);
      if (result.token !== 'valid') {
        this.isTokenValid = false;
      } else {
        this.isTokenValid = true;
      }
    },
  },
  beforeDestroy() {
    EventBus.$off('languageChanged');
  }
};
</script>
<style scoped>
li.reqrd-field,
.mandatory-field {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.7);
}

li.mandatory-field::before {
  content: "\f111";
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  color: #b00505;
  font-size: 11px;
  padding-right: 6.38px;
}
.cancel-icon {
  position: absolute;
  cursor: pointer;
  color: #828282;
  right: 11px;
}
#divPasswordValidationResult {
  display: block;
  padding: 0px;
  background: #ffffff;
  border: 1px solid #b00505;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.password-must {
  text-align: left;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
  padding-top: 10px;
  padding-left: 13px;
}
ul.password-cond {
  list-style-type: none;
  text-align: left;
  padding-left: 26px;
  padding-bottom: 10px;
}
.custom-checkbox input[type='checkbox']:checked ~ .select-check {
  background-color: #4D4D4D;
}
.checkbox-error-section{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #C01B21;
  margin-bottom: 16px;
}
.checkbox-error{
    padding: 7px 0px 7px 0px;
    background: #C01B21;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color:  #FFFFFF;
}
.check-box-error-info{
  width: 20px;
  height: 20px;
  margin: 6px 0px 6px 16px;
}
.chechBox-error-cancel-icon{
  margin-right: 16px;
  cursor: pointer;
}
.pb-9 {
  padding-bottom: 9px;
  /* margin-bottom: 12px; */
}
.pt-9 {
  padding-top: 9px !important;
}
.pb-14 {
  padding-bottom: 12px;
  margin-bottom: 26px;
}
.mb-26 {
   margin-bottom: 28px;
}
.change-password-black-text{
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.change-password-blue-text{
  font-weight: 600;
  font-size: 18px;
  line-height: 15px;
  color: #00518A;
}
input::placeholder {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #999999;
}
  .enter-a-password {
    text-align: center;
    padding-top: 24px;
    padding-left:3px;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: #3e3e3e;

  }
 .page_wrapper{
   margin-left: 0px;
   margin-right: 0px;
   position: relative;
   padding-bottom: 58px;
   min-height: 100vh;
   /* background-image: url('/static/images/logos/login_page_bg_image.jpg'); */
   background-repeat: no-repeat;
   background-size: cover;
   background-position: center;
   overflow-x: hidden;
   background: #ebebeb;
 }
 .justify-content-center{
   justify-content: center;
 }
 main {
   padding: 30px 20px;
 }
 .reset-whitebox{
   display: inline-block;
   margin-top: 135px;
   margin-bottom: 166px;
   padding: 10px;
   background:#FFFFFF;;
   /* border-radius: 3px; */
   max-width: 684px;
   /* min-width: 589px; */
   border: 1px solid #B3B3B3;
 }
 .page_header{
   font-family: 'Open Sans';
   font-style: normal;
   font-weight: 300;
   font-size: 42px;
   line-height: 57px;
   text-align: center;
   color: #333333;
   padding-top: 54px;
   padding-left: 76px;
   padding-right: 77px;
   margin-bottom: 0px;
 }
 form{
   /* padding-left: 73px;
     padding-right: 70px; */
     padding-top: 30px;
 }
 .reset-container{
     padding-right: 38px;
     padding-left: 37px;
 }
 .reset-input input:focus{
   outline:none !important;
   outline-width: 0 !important;
   box-shadow: none;
   -moz-box-shadow: none;
   -webkit-box-shadow: none;
    border: 1px solid #0A99FF;
 }
 label {
     font-weight: 400;
     font-family: 'Open Sans';
     font-style: normal;
      font-size: 16px;
      line-height: 22px;
      padding-right: 4px;
      margin: 0;
      color: #3e3e3e;
      padding-bottom: 7px;
 }
 .required_astric{
   color: #B00505;
   font-size: 16px;
 }
 .reset-input-box-without-icon{
   padding: 5px 11px;
 }
 .landing-input-field {
   width: 100%;
   -webkit-box-sizing: border-box;
   box-sizing: border-box;
   border-radius: 3px;
   border: 1px solid #4D4D4D;
  font-family: 'Open Sans' !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #4D4D4D;
 }
 #togglePassword{
   cursor: pointer;
   float: right;
   position: relative;
   top: -29px;
   right: 16px;
 }
 .landing-input-field.field_error{
   border: 1px solid #E12D33
 }
 .error_text{
   margin-top: 0px;
   margin-bottom: 12px;
   border-bottom-left-radius: 0px;
   border-bottom-right-radius: 0px;
   /* background-color:  rgba(176, 5, 5, 0.1); */
   padding: 0px;
 }
 .error_text p{
   font-family: 'Open Sans';
   font-style: normal;
   font-weight: 400;
   font-size: 14px;
   line-height: 19px;
   color: #E12D33;
   /* padding-left: 8px; */
   /* padding-top: 9px; */
   /* padding-bottom: 5px; */
   margin:0 !important;
 }
 .change-password-btn{
   padding-left: 37px;
   padding-right: 38px;
   padding-top: 15px;
   margin-bottom: 54px;
 }
 .confirm-btn {
   padding: 9px 9px;
   width: 100%;
   background-color: #01518A !important;
   border-color: #01518A !important;
   color: #FFFFFF !important;
  font-family: 'Open Sans' !important;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
    border-radius:3px;
    border:none;
 }
 .confirm-btn[disabled] {
   /* opacity: 1; */
    cursor: not-allowed;
  -webkit-box-shadow: none;
  box-shadow: none;
   background-color: rgba(1, 81, 138, 0.5) !important;
  /* border-color: rgba(1, 81, 138, 0.5) !important; */
  border:none !important;
 }
 .pr-66 {
  padding-right: 66px;
 }
 .pr-42 {
  padding-right:42px;
 }
 .button-success[disabled]:hover{
   background-color: rgba(1, 81, 138, 0.5) !important;
  border-color: rgba(1, 81, 138, 0.5) !important;
}

.button-success:hover{
  background-color: #01518A !important;
  border-color: #01518A !important;
}
 /* @media screen and (max-width: 640px) {
 .reset-whitebox {
     min-width: 90vw;
   }
 } */
 /* @media screen and (max-width: 767px) {
   .reset-whitebox{
     margin-top: 76px;
     margin-bottom: 0;
   }
   .page_header{
   padding-left: 36px;
     padding-right: 45px;
 }
   .reset-container{
     padding-right: 31px;
     padding-left: 33px;
 }
   .confirm-checkbox-container{
   padding-right: 31px;
   padding-left: 41px;
 }
 .change-password-btn{
   padding-left: 38px;
   padding-right: 38px;
 }
 .checkbox-error-section{
   padding-right: 31px;
     padding-left: 33px;
 }
 } */
 /* .terms-conditions {
   font-weight: 400;
   font-size: 16px;
 }
 .txt-alg-ctr {
   text-align: center;
 }
 .submit-btn {
   padding-left: 30px;
   padding-right: 30px;
   margin-top: 30px;
 }
 .mb-20 {
   margin-bottom: 20px;
 }
 .password-container {
   color: #000;
   font-family: 'Open Sans', sans-serif;
 }
 .password-container h1 {
   font-family: "Poppins", sans-serif;
   font-weight: 700;
   font-size: 48px;
   margin-bottom: 16px;
   line-height: 1;
 }
 .password-container p {
   font-size: 16px;
 }
 .password-container a {
   font-weight: 700;
   font-size: 16px;
   text-decoration: none;
   color: rgb(20, 150, 60);
   -webkit-transition: all 0.1s ease;
   -o-transition: all 0.1s ease;
   transition: all 0.1s ease;
   border: 0;
   padding-bottom: 5px;
 }
 .password-container a:hover,
 .password-container a.active {
   border-bottom: 2px solid rgb(20, 150, 60);
 } */
 .pr-0 {
  padding-right: 0px !important;
 }

.pl-15 {
  padding-left: 15px !important;
 }
 .pr-20 {
  padding-left: 20px !important;
 }
 .pt-6 {
  padding-top: 6px;
 }
 .plr-39-42 {
  padding-left: 39px;
  padding-right: 42px;
  display: flex;
 }
 </style>
